var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlphabetic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.451,
    height: 25.341,
    viewBox: "0 0 26.451 25.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-sort-by-alpha",
    "data-name": "Icon material-sort-by-alpha",
    d: "M19.825,6.533H13.66L16.743,3.45ZM13.7,25.748h6.087l-3.044,3.044ZM8.278,8.636,2.4,23.605H4.8l1.2-3.2H12.68l1.2,3.2h2.4L10.42,8.636ZM6.8,18.263,9.336,11.5l2.534,6.766Zm14.055,3.266h7.994v2.077H17.709V21.92l7.733-11.181H17.761V8.649H28.6v1.646L20.857,21.528Z",
    transform: "translate(-2.4 -3.45)",
    fill: "#bf772f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabetic);
export default __webpack_public_path__ + "static/media/alphabetic.9c9721185fb3a20a73f47aadf129254a.svg";
export { ForwardRef as ReactComponent };